module.exports = __webpack_public_path__ + "assets/img/CSS.011a1b9b.png";